import React from 'react';
import {
	Button,
	Checkbox,
	FormControlLabel,
	Grid,
	MenuItem,
	TextField,
	InputLabel,
	FormControl as FormControlMui
} from '@mui/material';
import styled from 'styled-components';
import DeleteSvg from 'shared/statics/svg/Delete.svg';

const ChipsArray = ({ recipients, removeRecipient, users }) => {
	const getMail = (id) => {
		return users.filter(({ dbId }) => dbId === id)?.[0]?.email ?? '';
	};
	return (
		<RecipientList>
			{recipients.map((recipient) => <div key={recipient.id}>
				<label>{recipient.name} <LabelMail>{getMail(recipient.id)}</LabelMail></label>
				<DeleteIcon onClick={() => removeRecipient(recipient.id)} />
			</div>)}
		</RecipientList>
	);
};

export default function Recipients({ users, form, isTimed, donorDefault }) {
	const { values, setFieldValue } = form;
	const [selectedUser, setSelectedUser] = React.useState('');
	const [errors, setErrors] = React.useState({}) // eslint-disable-line

	const handleAddRecipient = () => {
		if (!selectedUser) return;
		const recipients = [...values.recipients];
		const inList = (values.recipients.filter(item => item.id === selectedUser.dbId).length > 0);
		if (inList) {
			return;
		}
		recipients.push({
			id: selectedUser.dbId,
			name: `${selectedUser.firstName} ${selectedUser.lastName}`
		});
		setSelectedUser('');
		setFieldValue('recipients', recipients);
	};

	const removeRecipient = (id) => {
		setFieldValue('recipients', values.recipients.filter(user => user.id !== id));
	};

	return (
		<Grid container direction="row" justify="center" alignItems="center">
			<Grid item xs={12}>
				<p>Recipients:</p>
				<FormControlLabel
					control={<Checkbox
						checked={values.recipientIncludeNpo}
						onChange={e => setFieldValue('recipientIncludeNpo', e.target.checked)}
						color="primary"
					/>}
					label={`${values.ruleTrigger === 14 ? 'NPO Investment Recipient' : 'NPO Program Manager'}`}
				/>
			</Grid>
			<Grid item xs={12}>
				<FormControlLabel
					control={<Checkbox
						checked={values.recipientIncludeProgramManager}
						onChange={e => setFieldValue('recipientIncludeProgramManager', e.target.checked)}
						color="primary"
					/>}
					label={'Donor Program Manager'}
				/>
			</Grid>
			<Grid item xs={12}>
				<FormControlLabel
					control={<Checkbox
						checked={values?.recipientIncludeAllNpoUsers}
						onChange={e => setFieldValue('recipientIncludeAllNpoUsers', e.target.checked)}
						color="primary"
					/>}
					label={'All NPO Users'}
				/>
			</Grid>
			<p>Additional recipients:</p>
			{values.recipients && values.recipients.length > 0 && (<Grid item xs={12}>
				<ChipsArray recipients={values.recipients} removeRecipient={removeRecipient} users={users} />
			</Grid>
			)}
			<Grid item xs={12} className="flexGrid">
				<FormControl>
					{!selectedUser && <InputLabel id="recipient-label">Choose Recipient</InputLabel>}
					<TextField
						labelId="recipient-label"
						renderValue={(user) => user ? `${user.firstName} ${user.lastName}` : ''}
						onChange={(_, { props }) => setSelectedUser(props.value)}
						error={errors.recipients || form.errors.recipients}
						select
						fullWidth
					>
						{users.filter(u => u.enabled).map((user) => (
							<MenuItem key={user.dbId} value={user}>
								<LabelName>{`${user.firstName} ${user.lastName} `}</LabelName> <LabelMail>{user.email}</LabelMail>
							</MenuItem>
						))}
					</TextField>
				</FormControl>
				<Button variant="outlined" onClick={handleAddRecipient}>Add</Button>
			</Grid>
		</Grid>
	);
}

const RecipientList = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: column;
	margin-bottom: 16px;
	div {
		display: flex;
		flex-direction: row;
		flex: 1;
		justify-content: space-between;
		margin-bottom: 8px;
		label {
			color: #48596B;
			font-size: 16px;
			font-weight: 400;
		}
		svg {
			cursor: pointer;
			color: #0072A2;
		}
	}
`;

const DeleteIcon = styled.span`
	width: 19px;
	height: 19px;
	background-size: cover;
	background-image: url(${DeleteSvg});
`;

const FormControl = styled(FormControlMui)`
	width: 100%;
	#recipient-label {
		font-size: 16px;
		font-weight: 400;
		color: #48596B;
		top: 5px;
	}
`;
const LabelName = styled.span`
	font-size: 12px;
	font-weight: 400;
`;
const LabelMail = styled.span`
	font-size: 11px;
	font-weight: 400;
	font-style: italic;
	color: #6cabc7;
`;